export const version = 'kunde-v1.15.0';